var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRecyclingAndPlasticFree = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Water-Bottle--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Water Bottle Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.72 10.25a0.51 0.51 0 0 0 0.5 -0.44 4.27 4.27 0 0 0 -0.8 -3.09 6.79 6.79 0 0 0 -3.73 -2.45l-0.12 0H9.5l-0.13 0a7 7 0 0 0 -3.79 2.45 4.27 4.27 0 0 0 -0.8 3.09 0.51 0.51 0 0 0 0.5 0.44Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2.75a0.5 0.5 0 0 0 0.5 -0.5V1.5A1.5 1.5 0 0 0 13 0h-2a1.5 1.5 0 0 0 -1.5 1.5v0.75a0.5 0.5 0 0 0 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78 11.75a0.53 0.53 0 0 0 -0.38 0.18 0.5 0.5 0 0 0 -0.11 0.41 12.86 12.86 0 0 1 0.21 2.17 10.29 10.29 0 0 1 0 1.2 0.5 0.5 0 0 0 0.5 0.54h12.1a0.5 0.5 0 0 0 0.5 -0.54 10.29 10.29 0 0 1 -0.05 -1.2 12.86 12.86 0 0 1 0.21 -2.17 0.47 0.47 0 0 0 -0.11 -0.41 0.51 0.51 0 0 0 -0.38 -0.18Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.88 18.16a0.49 0.49 0 0 0 -0.49 -0.41H5.61a0.49 0.49 0 0 0 -0.49 0.41C5 19 4.76 20 4.51 21.05A2.14 2.14 0 0 0 5 22.87 3.12 3.12 0 0 0 7.33 24a2.84 2.84 0 0 0 2.34 -1.23 2.82 2.82 0 0 0 4.66 0A2.84 2.84 0 0 0 16.67 24 3.12 3.12 0 0 0 19 22.87a2.14 2.14 0 0 0 0.45 -1.82C19.24 20 19 19 18.88 18.16Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRecyclingAndPlasticFree);
export default ForwardRef;